import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const H3 = styled.h1`
  font-size: 28px;
  font-weight: 600;
`;

export default H3;
